import CVSectionHeader from '../cv-section-header/CVSectionHeader';
import styles from './CVPersonal.module.css';

function CVPersonal() {
    return (
        <div className={styles['cv-personal']}>
            <CVSectionHeader title='Personal' />

            <p className={styles['cv-personal-info']}>
                At the age of 42, I am married with two children. I find great enjoyment in
                combining walking and meditation, often engaging in these activities for extended
                periods. Additionally, I am an avid reader, exploring a diverse range of literary
                genres. Squash and Padel courts serve as a constant source of camaraderie and
                enjoyment for me.
            </p>
        </div>
    );
}

export default CVPersonal;
